import formatDate from "./formatDate";

function getNestedValue(obj, path) {
  return path
    .split(".")
    .reduce(
      (acc, part) => (acc && acc[part] !== undefined ? acc[part] : ""),
      obj
    );
}

function applyTextTransform(value, styles) {
  if (typeof value !== "string") return value;
  if (!styles || !styles.textTransform) return value;

  switch (styles.textTransform) {
    case "uppercase":
      return value.toUpperCase();
    case "lowercase":
      return value.toLowerCase();
    case "capitalize":
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    default:
      return value;
  }
}

export const generateCSVData=(headers, data)=> {
  const csvData = [];

  // Add header titles first row
  const headerTitles = headers.map((h) => h.title);
  csvData.push(headerTitles);

  // Add each data row
  data.forEach((item) => {
    const row = headers.map((h) => {
      let value = getNestedValue(item, h.key);

      if (h.isMoment && value) {
        value = formatDate(value, h.formatTime || "YYYY-MM-DD");
      }

      if (h.styles) {
        value = applyTextTransform(value, h.styles);
      }

      return value;
    });

    csvData.push(row);
  });

  return csvData;
}

